/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from "rxjs";
import { first, map } from "rxjs/operators";
import { selectCirculationIsLoading } from "src/app/circulation/state";
import { Logger } from "src/app/logger";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { AbstractAdminService } from "../admin.service";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ICreateReportData } from "src/app/interfaces/report";
import { ReportService } from "src/app/services/report.service";

@Component({
    selector: "circ-admin-dashboard",
    templateUrl: "./admin-dashboard.component.html",
    styleUrls: ["./admin-dashboard.component.scss"],
    standalone: false
})
export class AdminDashboardComponent implements OnInit {
  public get enableDebugLogging(): boolean {
    return Logger.logDebug;
  }

  public set enableDebugLogging(v: boolean) {
    Logger.logDebug = v;
  }

  public isLoading$: Observable<boolean>;
  public circulationsData$: Observable<{ status: string; share: string }[]>;
  public totalCount$: Observable<number>;
  public isWorking = new BehaviorSubject<boolean>(false);
  public syncCircDialogVisible = false;
  public syncCircDialogCount = 0;

  public formGroup = new UntypedFormGroup({
    circulationId: new UntypedFormControl(0, [Validators.required]),
    overrideExisting: new UntypedFormControl(false, [Validators.required])
  });

  constructor(
    private store: Store,
    private circulationFacade: CirculationFacade,
    private adminService: AbstractAdminService,
    private reportService: ReportService
  ) {
    this.isLoading$ = this.store.select(selectCirculationIsLoading);
    const circulations$ = this.circulationFacade.getCirculationProps();
    this.totalCount$ = this.circulationFacade.total();

    this.circulationsData$ = circulations$.pipe(
      map((circulations) => {
        const statusValues = [...new Set(circulations.map((c) => c.status))];
        const totalCount = circulations.length;

        const chartData = [];
        statusValues.forEach((status) => {
          const count = circulations.filter((c) => c.status === status).length;
          const share = count / totalCount;
          chartData.push({ status: status, share });
        });

        return chartData;
      })
    );

    this.circulationFacade.getAllCirculations();
  }
  ngOnInit(): void {
    this.formGroup.setValue({
      circulationId: 0,
      overrideExisting: false
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public labelContent(e: any): string {
    return (Math.trunc(e.percentage * 100) / 100).toString();
  }

  public syncCircsToSp() {
    this.isWorking.next(true);
    this.adminService
      .syncCirculationsToSharePoint()
      .pipe(first())
      .subscribe((no) => {
        this.syncCircDialogCount = no;
        this.syncCircDialogVisible = true;
        this.isWorking.next(false);
      });
  }

  public createReport(){
    const data = this.formGroup.value;
    let ownerId = null;

    this.circulationFacade.getCirculation(data.circulationId).subscribe(circ => {
      ownerId = circ.props.owner[0]?.id ?? null;
    });

    if(data.circulationId <= 0 || ownerId === null) {
      console.error("Form is invalid. Please correct the errors and try again.");
      console.error("CirculationId:", data.circulationId, " OwnerId:", ownerId);
      return;
    }

    const dto: ICreateReportData = {
      circulationId: +data.circulationId,
      ownerId: ownerId,
      overrideExisting: data.overrideExisting
    }

    this.reportService.CreateCirculationReport(dto).subscribe(() => {
    }, (error) => {
      console.error("Error creating report:", error);
    });
  }
}
